import React, { useState } from "react";
import Hero from "./hero";
import FeaturesBlock from "./features-block";
import AttorneyForm from "../../components/form/attorney-form";
import useAttorneyFormSubmit from "../../hooks/useAttorneyFormSubmit";
import SuccessMessage from "../../components/success-message";

const AttorneyLandingPage = () => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const { methods, handleSubmit } = useAttorneyFormSubmit({
    setOnSuccess: setShowSuccessMessage,
  });

  return (
    <>
      <Hero title={"WORKING WITH US"} />
      <FeaturesBlock />
      <div className="w-full max-w-3xl mx-auto px-4 sm:px-6">
        {showSuccessMessage ? (
          <SuccessMessage message={"We'll be in touch soon :)"} className="text-black"/>
        ) : (
          <AttorneyForm methods={methods} handleSubmit={handleSubmit} />
        )}
      </div>
    </>
  );
};

export default AttorneyLandingPage;
